import { Segment } from '@mairistem/composants';
import { ModeReglementContextProvider } from '../Context';
import CycleContextProvider from '../Context/CycleContextProvider';
import CyclesListe from './CyclesListe';

/**
 * Composant servant pour le points de menu "Cycles de facturation incorporés"
 */
const CyclesMenu = () => (
  <Segment basic secondary style={{ margin: 0, height: '100%' }}>
    <Segment style={{ height: '100%', overflow: 'hidden' }} id="factures-recus">
      <ModeReglementContextProvider autoload="régie">
        <CycleContextProvider>
          <CyclesListe />
        </CycleContextProvider>
      </ModeReglementContextProvider>
    </Segment>
  </Segment>
);

export default CyclesMenu;
